import type { JSX } from 'react'
import type { Location, RouterResponse } from '~/core/router'

import { ErrorBoundary } from 'react-error-boundary'
import { Loader } from '~/shared/ui/components/Loader'
import { ErrorFallback, errorHandler } from './ErrorFallback'
import { Page } from './Page'
import { ThemeProvider } from './ThemeProvider'
import { TopPageNotification } from './TopPageNotification'

interface Props {
  location: Location
  route: RouterResponse | undefined
}

App.displayName = 'App'
export function App({ location, route }: Props): JSX.Element {
  return (
    <ThemeProvider>
      <Loader />
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={errorHandler}
        resetKeys={[location.key]}
      >
        <TopPageNotification />
        <Page route={route} />
      </ErrorBoundary>
    </ThemeProvider>
  )
}
